export type CheckStatus = "NOT_CHECKED" | "OK" | "OBSERVATION" | "DEFECT" | "NOT_APPLICABLE";
export type CheckType = "STATUS" | "NUMERIC" | "TEXT" | "OPTION" | "PHOTO" | "COMPOSITE";
export type Severity = "INFO" | "MINOR" | "MAJOR" | "CRITICAL";

export interface MediaRef { id: string; kind: string; caption: string | null }
export interface CheckView {
  id: string; key: string; label: string; instructions: string | null;
  checkType: CheckType; unit: string | null; config: { options?: string[]; fields?: { key: string; label: string; type: string; unit?: string; options?: string[] }[] } | null;
  required: boolean; photoRequired: boolean; sortOrder: number;
  status: CheckStatus; value: Record<string, unknown> | null; comment: string | null; severity: Severity | null;
  media: MediaRef[];
}
export interface Counts { total: number; checked: number; ok: number; observation: number; defect: number; notApplicable: number; notChecked: number }
export interface SectionView { id: string; key: string; title: string; counts: Counts; checks: CheckView[] }
export interface FindingView { id: string; checkId: string | null; vehicleArea: string | null; title: string; severity: Severity; description: string | null }
export interface InspectionHeader {
  id: string; status: "IN_PROGRESS" | "SIGNED" | "SUBMITTED"; templateVersion: number | null;
  overallRecommendation: string | null; conclusion: string | null; recommendedRepairs: string | null;
  negotiationPoints: string | null; notPerformedNotes: string | null; location: string | null;
}
export interface InspectionView {
  inspection: InspectionHeader;
  counts: Counts;
  sections: SectionView[];
  findings: FindingView[];
  signature: { signerName: string; signedAt: number } | null;
}

export const STATUS_META: Record<CheckStatus, { label: string; tone: "ok" | "warn" | "danger" | "neutral"; icon: string }> = {
  OK: { label: "OK", tone: "ok", icon: "✓" },
  OBSERVATION: { label: "Observación", tone: "warn", icon: "!" },
  DEFECT: { label: "Defecto", tone: "danger", icon: "✕" },
  NOT_APPLICABLE: { label: "N/A", tone: "neutral", icon: "–" },
  NOT_CHECKED: { label: "Sin comprobar", tone: "neutral", icon: "?" },
};
export const SEVERITIES: Severity[] = ["MINOR", "MAJOR", "CRITICAL"];

export function pct(c: Counts): number {
  if (c.total === 0) return 0;
  return Math.round((c.checked / c.total) * 100);
}
